import React from "react";
import { PageLayout } from "../components/PageLayout";
import { ProductDetail } from "../features/products/ProductDetail";

export const ProductDetailsPage: React.FC = () => {
  return <PageLayout>
    <ProductDetail />
  </PageLayout>;
};